export default "__VITE_ASSET__BHAutY02__"